<template>
  <div v-if="_visible" class="versionManage">
    <module-title :title="handleType == 'add'? '新增版本' : '编辑版本'">
      <div class="right">
        <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="back">
          返回
        </el-button>
      </div>
    </module-title>
    <el-form
      ref="addVersionForm"
      :model="addVersionForm"
      :rules="handleRules"
      label-position="right"
      label-width="150px"
    >
      <el-form-item label="应用名称：" prop="appName">
        <el-input
          v-model="appName"
          disabled
          name="name"
          :maxlength="50"
          placeholder=""
          class="handle-form-input"
        />
      </el-form-item>
      <el-form-item label="应用版本：" prop="versionName">
        <el-input
          v-model="addVersionForm.versionName"
          name="name"
          :maxlength="50"
          disabled
          placeholder="自动获取"
          class="handle-form-input"
        />
      </el-form-item>
      <el-form-item label="关联应用选择：" prop="campusAppVersionIds">
        <el-select
          key="teacherApplication"
          v-model="addVersionForm.campusAppVersionIds"
          filterable
          class="handle-form-input"
        >
          <el-option
            v-for="item in teacherAppUpgrades"
            :key="item.id"
            :label="`${item.appName} ${item.versionCode}  ${item.iterationNumber}`"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <div class="apk-box">
        <div class="teacher-apk">
          <el-form-item label="安装包：" label-width="80px">
            <upload-file
              :props="{serveCode:'small_app_file',
                       accept:'.apk',
                       type:['application/vnd.android.package-archive']}"
              :handle-type="handleType"
              @uploadSucess="uploadSucessFn"
              @fileUploading="fileUploadingFn"
              @apkParser="apkParserFn"
            >
              <el-button
                :loading="fileUploading"
                size="small"
                type="primary"
                icon="el-icon-upload2"
                :disabled="handleType == 'edit'"
              >
                {{ fileUploading?'上传文件中...':'上传apk' }}
              </el-button>
            </upload-file>
          </el-form-item>
          <el-form-item label="包名：" prop="packageName" label-width="80px">
            <el-input
              v-model="addVersionForm.packageName"
              placeholder="自动获取"
              name="packageName"
              class="handle-form-input"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item label="MD5值：" prop="md5" label-width="80px">
            <el-input
              v-model="addVersionForm.md5"
              placeholder="自动获取"
              name="md5"
              class="handle-form-input"
              :disabled="true"
            />
          </el-form-item>
        </div>
      </div>
      <el-form-item label="更新说明：" prop="introduction">
        <el-input
          v-model="addVersionForm.introduction"
          type="textarea"
          :rows="6"
          placeholder="请输入用更新说明，建议不超过150个汉字！"
          class="handle-form-textarea"
          maxlength="150"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer footer-btn">
      <el-button size="medium" @click="back">
        取消
      </el-button>
      <el-button
        :loading="ajaxLoading"
        type="primary"
        size="medium"
        @click="handleAddVersion"
      >
        {{ ajaxLoading?'Loading':'确定' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { formatTimeToStr } from '@/utils/index';

import {
  addVersion,
  updateVersion
} from '@/api/productOperation/classRoom/applicationList';
import {
  getVersions
} from '@/api/productOperation/wisdom/applicationList';
import { mapGetters } from 'vuex';
export default {
  name: 'AddVersion',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    handleType: {
      type: String,
      required: 'add'
    },
    appId: {
      type: String,
      required: true
    },
    appName: {
      type: String,
      required: true
    },
    updateRow: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      // 所有控制显示隐藏变量
      hiddenVariable: {
        addVersionVisible: false // 学生详情
      },
      listLoading: false, // 表格刷新loading
      versionManage: [],
      ajaxLoading: false, //  表单提交loading
      dialogImageUrl: '',
      addVersionForm: {},
      handleRules: {
        name: [
          { required: true, message: '应用名称不能为空', trigger: 'blur' }
        ],
        md5: [
          { required: true, message: 'MD5不能为空', trigger: 'blur' }
        ],
        packageName: [
          { required: true, message: '包名不能为空', trigger: 'blur' }
        ],
        introduction: [{ required: true, message: '说明不能为空', trigger: 'blur' }],
        campusAppVersionIds: [{ required: true, message: '关联应用选择不能为空', trigger: 'change' }]
      },
      // 上传应用信息
      fileUploading: false,
      teacherAppUpgrades: [] // 教师应用列表
    };
  },
  computed: {
    _visible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    formatTimeToStr() {
      return formatTimeToStr;
    },
    ...mapGetters(['currentProdeuctId', 'userInfo']),
    userCode() {
      return this.userInfo.roleVOList[0].createUserCode;
    }
  },
  watch: {
    _visible(val) {
      if (this.handleType === 'edit') {
        this.addVersionForm = {
          md5: this.updateRow.md5,
          packageName: this.updateRow.packageName,
          versionName: this.updateRow.versionName,
          introduction: this.updateRow.introduction,
          campusAppVersionIds: this.updateRow.appVersions && this.updateRow.appVersions.length > 0 && this.updateRow.appVersions[0].id
        };
      } else {
        this.addVersionForm = {
          introduction: '', // 升级描述
          packageName: '',
          md5: '',
          versionUrl: '',
          fileSize: '',
          versionName: '',
          campusAppVersionIds: ''
        };
      }
    }
  },
  mounted() {
    this.initForm();
  },
  methods: {
    initForm() {
      getVersions({ codes: [33] + '' }).then((res) => {
        this.teacherAppUpgrades = res.data;
      });
    },
    cancel() {
      this._visible = false;
      this.$parent('openView');
    },
    uploadSucessFn(val) {
      console.log(val);
      this.addVersionForm.appId = this.appId;
      this.addVersionForm.versionCode = val.versionCode;
      this.addVersionForm.packageName = val.package;
      this.addVersionForm.versionName = val.versionName;
      this.addVersionForm.md5 = val.md5Value;
      this.addVersionForm.versionUrl = val.absolutePath;
      this.fileUploading = false;
    },

    fileUploadingFn(val) {
      this.addVersionForm.md5 = '';
      this.addVersionForm.versionName = '';
      this.addVersionForm.packageName = '';
      this.fileUploading = val;
    },
    apkParserFn(val) {
      this.addVersionForm.fileSize = val.file.size;
      const ApkParser = require('app-info-parser/src/apk');
      const parser = new ApkParser(val.file);
      parser.parse().then(result => {
        this.uploadSucessFn({ ...result, ...val });
      }).catch(err => {
        console.log('err ----> ', err);
        this.$notify.success({
          title: 'error',
          message: '上传出错，请检查安装包是否正确！',
          showClose: false,
          duration: 2000
        });
      });
    },

    // 添加应用
    handleAddVersion() {
      this.$refs['addVersionForm'].validate(valid => {
        if (valid) {
          this.ajaxLoading = true;
          if (this.handleType === 'add') {
            const data = {
              ...this.addVersionForm,
              campusAppVersionIds: this.addVersionForm.campusAppVersionIds ? [this.addVersionForm.campusAppVersionIds] : []
            };
            addVersion(data)
              .then(result => {
                this.$notify.success({
                  title: 'Success',
                  message: '添加成功',
                  showClose: false,
                  duration: 2000
                });
                this.ajaxLoading = false;
                this._visible = false;
                this.$parent.openView();
                this.$parent.fetchversionManage();
              })
              .catch(err => {
                console.log(err);
                this.ajaxLoading = false;
              });
          } else {
            const data = {
              updateUserCode: this.userCode,
              introduction: this.addVersionForm.introduction,
              campusAppVersionIds: this.addVersionForm.campusAppVersionIds ? [this.addVersionForm.campusAppVersionIds] : []
            };
            updateVersion(this.updateRow.id, data)
              .then(result => {
                this.$notify.success({
                  title: 'Success',
                  message: '编辑成功',
                  showClose: false,
                  duration: 2000
                });
                this.ajaxLoading = false;
                this._visible = false;
                this.$parent.openView();
                this.$parent.fetchversionManage();
              })
              .catch(err => {
                console.log(err);
                this.ajaxLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 返回
    back() {
      // true 提示， false直接返回
      // if (this.handleType !== 'add') {
      //   this._visible = false;
      //   return;
      // }
      const flag = Object.values(this.addVersionForm).some((item) => {
        return item.length > 0;
      });
      if (!flag) {
        this._visible = false;
        this.$parent.openView();
      } else {
        this.$confirm('您已输入部分内容，是否确认返回?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this._visible = false;
            this.$parent.openView();
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消返回!'
            });
          });
      }
      // this._visible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.versionManage {
  padding-bottom: 20px;
}
.handle-form-input {
  width: 300px;
}
.handle-form-textarea {
  width: 400px;
}
.eidt-pictures {
  float: left;
  .eidt-pictures-item {
    display: inline-block;
    position: relative;
    img {
      width: 148px;
      height: 148px;
      margin-right: 10px;
      border-radius: 6px;
      cursor: pointer;
    }
    .el-icon-error {
      position: absolute;
      top: 0;
      right: 10px;
      cursor: pointer;
      font-size: 16px;
      color: #f56c6c;
    }
  }
}
.el-upload-picture {
  float: left;
}
.footer-btn{
  margin-left: 200px;
}
.apk-box{
  display: flex;
  margin-left: 150px;
  margin-bottom: 20px;
}
.teacher-apk{
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
}
.student-apk{
  padding: 12px;
  margin-left: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
}
</style>
